import React from "react";
import PropTypes from 'prop-types';
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import {TextField, Tooltip} from "@material-ui/core";
import {errorHandler} from "../../Utils/errorHandler";
import SortableItem from "../../../../ReactSelectMaterial/Sortable/SortableItem";
import Chip from "@material-ui/core/Chip";
import SortableContainer from "../../../../ReactSelectMaterial/Sortable/SortableContainer";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../Components/JsonScreen/Utils/lib";

const useStyles = makeStyles(() => ({
    inputRoot: {
        '&[class*="MuiInput-root"]': {
            paddingRight: 0,
            '& $input': {
                padding: '3px 4px !important',
            },
        },
        '&[class*="MuiOutlinedInput-root"]': {
            paddingRight: '0 !important',
            padding: '1px !important'
        },
    },
    textFieldRoot: {
        '& .MuiInput-underline:before': {
            borderBottomColor: 'rgba(0,0,0,0.22)', // Semi-transparent underline
        },
    },
    option: {
        minHeight: 2,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        cursor: 'pointer',
        boxSizing: 'border-box',
        outline: '0',
        WebkitTapHighlightColor: 'transparent',
        paddingTop: '1px !important',
        paddingBottom: '2px !important',
        paddingLeft: '16px !important',
        paddingRight: '16px important',
    },
    paper: {
        width: 'auto',
        '& > ul': {
            maxHeight: 200,
            overflow: 'auto',
        },
    },
    clearIndicator: {
        display: 'none',
    },
    tag: {
        height: '24px'
    },
}));

const ArrayField = (props) => {
    const {
        fieldValue, onChange, required, disabled, filterValue, onBlur, isMobile, label,
        error, errors, fieldRef, onChangeTextField,
        options, swapItems, endDrag, field, fieldStyles, autofocus, path, type,
        fieldPresentation, placeholder
    } = props;
    const classes = useStyles();
    const userLanguage = useSelector(state => state.app.userLanguage);
    const inputClassName = fieldStyles.withoutStyles ? 'horizontal-fields-table' : 'form-dynamic-default';
    const customStyles = (isMobile || fieldStyles.presentation === 'standard') ? {
            width: '100%',
            marginTop: 4
        } :
        {
            width: '100%',
            margin: fieldStyles.margin,
            paddingTop: fieldStyles.withoutPadding ? 0 : !isMobile && 3,
            paddingLeft: fieldStyles.withoutPadding ? 0 : !isMobile && 2,
        };
    return (
        <SortableContainer>
            <Autocomplete
                value={fieldValue}
                onChange={onChange}
                required={required}
                disabled={disabled}
                multiple
                getOptionLabel={option => type === 'objSelect' ? option[field.optLabel || "label"] : option.label}
                classes={{
                    inputRoot: classes.inputRoot,
                    clearIndicator: classes.clearIndicator,
                    option: classes.option,
                    paper: classes.paper,
                    tag: classes.tag,
                }}
                inputValue={filterValue}
                onBlur={onBlur}
                renderInput={params =>
                    <TextField
                        {...params}
                        placeholder={multiLanguageValue(placeholder, userLanguage)}
                        required={required && (fieldValue === null || !fieldValue.length)}
                        label={(isMobile || fieldStyles.presentation === 'standard') && multiLanguageValue(label, userLanguage)}
                        variant={isMobile ? 'standard' : fieldPresentation}
                        fullWidth={isMobile ? true : fieldStyles.fullWidth}
                        error={error.length > 0}
                        inputRef={fieldRef}
                        autoFocus={autofocus}
                        type={type}
                        onChange={onChangeTextField}
                        style={customStyles}
                        className={inputClassName}
                        classes={{root: classes.textFieldRoot}}
                        inputProps={{
                            ...params.inputProps,
                            style: {
                                height: fieldStyles.height,
                                width: '100%'
                            },
                            className: !fieldStyles.withoutStyles && 'with-styles',
                        }}
                    />}
                options={options}
                renderTags={(value, getTagProps) =>
                    value.map((tag, index) => {
                        let error = errorHandler(errors, `${path}.${index}`);
                        return (
                            <SortableItem
                                index={index}
                                key={tag && tag.idx}
                                moveCard={swapItems}
                                endDrag={endDrag}
                                element={field}
                            >
                                <Tooltip title={error.length > 0 ? error : ''}>
                                    <Chip
                                        id={`chip_${index}`}
                                        style={{
                                            border: error.length > 0 ? '1px solid red' : 'none'
                                        }}
                                        variant="default"
                                        label={type === 'objSelect' ? tag && tag[field.optLabel || "label"] : tag.label}
                                        tabIndex={-1}
                                        {...getTagProps({index})}
                                    />
                                </Tooltip>
                            </SortableItem>
                        )
                    })
                }
            />
        </SortableContainer>
    )
};

export default ArrayField;

ArrayField.propTypes = {
    onChange: PropTypes.func,
    onChangeTextField: PropTypes.func,
    onBlur: PropTypes.func,
    fieldValue: PropTypes.array,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    fieldRef: PropTypes.any,
    filterValue: PropTypes.string,
    isMobile: PropTypes.bool,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    fieldStyles: PropTypes.object,
    error: PropTypes.array,
    autofocus: PropTypes.bool,
    type: PropTypes.string,
    path: PropTypes.string,
    field: PropTypes.object,
    errors: PropTypes.array,
    endDrag: PropTypes.func,
    swapItems: PropTypes.func,
};
ArrayField.defaultProps = {
    fieldPresentation: 'outlined'
}